export default __webpack_public_path__ + "src/assets/swap.2a5f01bbed10f741e2a2d9cf1a505e9b.svg";